export const SALARY_LIST_REQUEST = 'SALARY_LIST_REQUEST';
export const SALARY_LIST_SUCCESS = 'SALARY_LIST_SUCCESS';
export const SALARY_LIST_FAIL = 'SALARY_LIST_FAIL';
export const SALARY_LIST_RESET = 'SALARY_LIST_RESET';